import script from "./CurrentSelectedSession.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrentSelectedSession.vue?vue&type=script&setup=true&lang=js"

import "./CurrentSelectedSession.vue?vue&type=style&index=0&id=76d6dd08&scoped=true&lang=css"

import exportComponent from "/home/forge/princes-trust.ac.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76d6dd08"]])

export default __exports__